<div class="cm-notification__main" #cmNotificationMain>
  <cm-basic-button
    *ngIf="!isSmallSize"
    [mode]="BasicButtonModes.FLAT"
    [size]="BasicButtonSizes.MEDIUM"
    (click)="markAllAsRead()"
    class="mr-2 mark-all-read"
  >
    {{ 'notifications.mark-all-read' | translate }}
  </cm-basic-button>
  <cm-icon-button
    *ngIf="isSmallSize"
    [mode]="BasicButtonModes.FLAT"
    [size]="BasicButtonSizes.MEDIUM"
    [color]="BasicButtonColors.PRIMARY"
    (clickEvent)="markAllAsRead()"
    icon="mark_email_read"
    class="mr-2 mark-all-read"
  >
  </cm-icon-button>
  <mat-tab-group class="tab-group" mat-align-tabs="start" (selectedTabChange)="selectOption($event)">
    <mat-tab *ngFor="let option of notificationOptions" label="{{ 'notifications.' + option | translate }}">
      <div class="cm-notification__body" *ngIf="displayNotification$ | async as notifications">
        <div *ngIf="showSpinner$ | async; else emptyState" class="spinner-container">
          <mat-spinner></mat-spinner>
        </div>
        <ng-container *ngFor="let notification of notifications">
          <cm-notification-item
            [notification]="notification"
            (notificationUpdated)="refreshNotifications()"
          ></cm-notification-item>
        </ng-container>
        <ng-template #emptyState>
          <ng-container *ngIf="notifications.length === 0">
            <div class="cm-notification__empty-state">
              <h3>{{ 'notifications.empty-state' | translate }}</h3>
            </div>
          </ng-container>
        </ng-template>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
